import type { FaqSection } from '~/graphql/generated/graphql';

import { fetchPublicFaqSections } from '~/graphql/documents/campaigns';

export const usePublicFaqSections = async (section: FaqSection) => {
  const { $urqlClient } = useNuxtApp();

  const { data, error } = await useAsyncData(
    `faq-public-sections-${section}`,
    () => $urqlClient.query(fetchPublicFaqSections, {}, { requestPolicy: 'network-only' }).toPromise(),
    {
      server: true,
      transform: (result) => {
        if (result.error) {
          throw result.error;
        }

        return result.data?.publicFaqSections ?? [];
      },
    },
  );

  const sections = computed<FaqSection[]>(() => data.value ?? []);

  return {
    sections,
    error,
  };
};
